import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import PageTransition from './components/PageTransition';
import Landing from './pages/Landing';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import CookiesPolicy from './pages/CookiesPolicy';
import Footer from './components/Footer';

function AppContent() {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    setIsTransitioning(true);
    // Navigate after a short delay to allow transition to start
    // Scroll to the top of the page
    setTimeout(() => {
      window.scrollTo(0, 0);
      navigate(path);
    }, 500);
  };

  const handleTransitionComplete = () => {
    setIsTransitioning(false);
  };

  return (
    <div className="app">
      <Navigation onNavigate={handleNavigate} />
      <PageTransition 
        isTransitioning={isTransitioning} 
        onTransitionComplete={handleTransitionComplete}
      >
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services" element={<Services onNavigate={handleNavigate} />} />
            <Route path="/products" element={<Products onNavigate={handleNavigate} />} />
            <Route path="/products/:id" element={<ProductDetail onNavigate={handleNavigate} />} />
            <Route path="/aboutus" element={<About onNavigate={handleNavigate} />} />
            <Route path="/contact" element={<Contact onNavigate={handleNavigate} />} />
            <Route path="/cookies-policy" element={<CookiesPolicy />} />
          </Routes>
        </main>
      </PageTransition>
      <Footer onNavigate={handleNavigate} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
